<div class="zn-stand-history-aside">
  <section class="zn-stand-history-aside-card">
    <h4>{{ 'Geographic::Entity.StandTransformationHistory.InitialStands' | abpLocalization }}</h4>

    @if (loading()) {
      <div class="zn-stand-history-aside-loading">
        {{ 'Geographic::Entity.StandTransformationHistory.LoadingDetail' | abpLocalization }}
      </div>
    } @else {
      <table class="zn-stand-history-detail-table">
        <thead>
          <tr>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.StandColumn' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.Cycle' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.Rotation' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.AreaColumn' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.AreaPercentageColumn' | abpLocalization }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of initialDetails(); track item.id) {
            <tr>
              <td>{{ getStandName(item) }}</td>
              <td>{{ item.cycleNumber ?? '-' }}</td>
              <td>{{ item.rotationNumber ?? '-' }}</td>
              <td>{{ item.area ?? '-' }}</td>
              <td>{{ item.areaPercentage ?? '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5">{{ 'Geographic::Entity.StandTransformationHistory.NoData' | abpLocalization }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </section>

  <section class="zn-stand-history-aside-card">
    <h4>{{ 'Geographic::Entity.StandTransformationHistory.FinalStands' | abpLocalization }}</h4>

    @if (loading()) {
      <div class="zn-stand-history-aside-loading">
        {{ 'Geographic::Entity.StandTransformationHistory.LoadingDetail' | abpLocalization }}
      </div>
    } @else {
      <table class="zn-stand-history-detail-table">
        <thead>
          <tr>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.StandColumn' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.Cycle' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.Rotation' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.AreaColumn' | abpLocalization }}</th>
            <th>{{ 'Geographic::Entity.StandTransformationHistory.AreaPercentageColumn' | abpLocalization }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of finalDetails(); track item.id) {
            <tr>
              <td>{{ getStandName(item) }}</td>
              <td>{{ item.cycleNumber ?? '-' }}</td>
              <td>{{ item.rotationNumber ?? '-' }}</td>
              <td>{{ item.area ?? '-' }}</td>
              <td>{{ item.areaPercentage ?? '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5">{{ 'Geographic::Entity.StandTransformationHistory.NoData' | abpLocalization }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </section>
</div>
